import dayjs from 'dayjs';

/**
 * 검색 옵션
 * Select
 * types: Array , 필요한 옵션이름
 */
export const searchTypeOptions = (types) => {
  const options = [
    { label: '선택하기', value: -1},
    { label: '주문번호', value: 'order_idx' },
    { label: '문서번호', value: 'idx' },
    { label: '지사명', value: 'branch_name' },
    { label: '교육원명', value: 'school_name' },
    { label: '교육원장명', value: 'school_leader_name' },
    { label: '강사명', value: 'teacher_name' },
    { label: '회원명', value: 'member_name' },
    { label: '보호자명', value: 'parent_name' },
    { label: '지사아이디', value: 'branch_id' },
    { label: '교육원아이디', value: 'school_id' },
    { label: '강사아이디', value: 'teacher_id' },
    { label: '회원아이디', value: 'member_id' },
    { label: '강사직급', value: 'teacher_grade' },
    { label: '연락처', value: 'cell_phone' },
    { label: '휴대폰번호', value: 'cell_phone' },
    { label: '전화번호', value: 'home_phone' },
    { label: '제목', value: 'title' },
    { label: '내용', value: 'content' },
    { label: '작성자', value: 'writer' },
    { label: '질문내용', value: 'qustion_content' },
    { label: '답변내용', value: 'reply_content' },
    { label: '교재명', value: 'book_name' },
    { label: '연결지사명', value: 'linked_branch' },
    { label: '적립금지급계정', value: 'hq_id' },
    { label: '적립금 내용', value: 'point_history' },
    { label: '신청자명', value: 'proposer_name' },
    { label: '시도/시군구', value: 'addr' },
    { label: '인계교육원명', value: 'handover_school_name' },
    { label: '인수교육원명', value: 'takeover_school_name' }
  ];

  return types.length ? options.filter((it) => types.includes(it.label)) : types;
};

/**
 * 연도
 * startYear
 *  (고정 연도) type String (지정연도)
 *  (변동 연도) type Number (0: 현재연도, 양수: 현재연도+startYear, 음수: 현재연도-startYear)
 * endYear
 *  (고정 연도) type String (지정연도)
 *  (변동 연도) type Number (0: 현재연도, 양수: 현재연도+endYear, 음수: 현재연도-endYear)
 * useAll
 * 선택하기 노출 여부
 */
export const yearOptions = (startYear, endYear, useAll=true) => {
  let start = typeof startYear === 'string' ? Number(startYear) : dayjs().add(startYear, 'year').year();
  if (start < 2025) start = 2025
  let end = typeof endYear === 'string' ? Number(endYear) : dayjs().add(endYear, 'year').year();

  const length = { length: end - start + 1 };
  const fnMap = (_, index) => ({ label: `${start + index}년`, value: `${start + index}` });
  const years = Array.from(length, fnMap);
  let options = useAll ? [{ label: '선택하기', value: '-1' }] : [];
  options = [...options, ...years];

  return options;
};

// 월(달)
export const monthOptions = [
  { label: '1월', value: '01' },
  { label: '2월', value: '02' },
  { label: '3월', value: '03' },
  { label: '4월', value: '04' },
  { label: '5월', value: '05' },
  { label: '6월', value: '06' },
  { label: '7월', value: '07' },
  { label: '8월', value: '08' },
  { label: '9월', value: '09' },
  { label: '10월', value: '10' },
  { label: '11월', value: '11' },
  { label: '12월', value: '12' }
];

// 가맹상담1차상태
export const storeCounsel1stResultOptions = [
  { label: '전체', value: '-1' },
  { label: '미작성', value: 1 },
  { label: '작성완료', value: 2 }
];
// 가맹상담최종결과
export const storeCounselResultOptions = [
  { label: '최종결과 전체', value: -1 },
  { label: '상담중', value: 1 },
  { label: '이력서승인', value: 2 },
  { label: '승인완료', value: 3 },
  { label: '가맹완료', value: 4 },
  { label: '반려', value: 5 }
];

// 가맹성공률
export const storeSuccessRateOptions = [
  { label: '전체', value: '-1' },
  { label: '상', value: '1' },
  { label: '중', value: '2' },
  { label: '하', value: '3' }
];

// 가맹유형
export const storeSchoolTypeOptions = [
  { label: '공부방형', value: 'A' },
  { label: '단독형', value: 'B' },
  { label: '샵인샵형', value: 'C' },
  { label: '교습소형', value: 'D' },
];

// 입회상담,승인진행상태
export const counselProgressStatusOptions = [
  { label: '전체', value: '-1' },
  { label: '지사배정대기', value: '0' },
  { label: '지사배정', value: '1' },
  { label: '교육원배정', value: '2' },
  { label: '상담완료', value: '3' },
  { label: '입회대기', value: '4' },
  { label: '입회승인', value: '5' },
  { label: '교육원미배정', value: '9' }
];

export const counselListProgressStatusOptions = [
  { label: '지사배정대기', value: '0' },
  { label: '지사배정', value: '1' },
  { label: '교육원배정', value: '2' },
  { label: '상담완료', value: '3' },
  { label: '입회대기', value: '4' },
  { label: '입회승인', value: '5' },
  { label: '교육원미배정', value: '9' }
];

// 강사참관상태
export const teacherObserveOptions = [
  { label: '전체', value: '-1' },
  { label: '참관완료', value: '1' },
  { label: '미완료', value: '2' }
];

// 마감보고서제출현황
export const closeSubmitOptions = [
  { label: '전체', value: '-1' },
  { label: '제출', value: '1' },
  { label: '미제출', value: '2' }
];

// 교육원등급제
export const schoolGradeOptions = [
  { label: '전체', value: '-1' },
  { label: '우수', value: '1' },
  { label: '전문', value: '2' },
  { label: '선임', value: '3' },
  { label: '수석', value: '4' },
  { label: '명예의전당', value: '5' }
];
//교육원 상태
export const schoolStatus = [
  { label: '운영', value: '1' },
  { label: '신규', value: '2' },
  { label: '휴업', value: '3' },
  { label: '해지', value: '4' },
  { label: '영업부진', value: '5' },
  { label: '등급제', value: '6' }
];
// 교육원사업자등록증
export const businessLicenseOptions = [
  { label: '전체', value: '-1' },
  { label: '등록', value: '1' },
  { label: '미등록', value: '2' }
];

// 회원구분
export const memberTypeOptions = [
  { label: '전체', value: '-1' },
  { label: '정회원', value: '1' },
  { label: '휴회회원', value: '2' },
  { label: '졸업(삭제)회원', value: '3' }
];

// // 회원구분
export const orderMemberTypeOptions = [
  { label: '전체', value: '-1' },
  { label: '정회원', value: '1' },
  { label: '휴회회원', value: '2' }
];
// 회원상태
export const memberStatusOptions = [
  { label: '미승인', value: '1' },
  { label: '승인', value: '2' },
  { label: '재입회', value: '3' },
  { label: '신규', value: '4' }
];

// 큐미르 회원나이
export const ageOptions = [
  { label: '전체', value: -1 },
  { label: '10세', value: 10 },
  { label: '11세', value: 11 },
  { label: '12세', value: 12 },
  { label: '13세', value: 13 },
  { label: '14세', value: 14 },
];
// 큐미르 회원나이 컬럼
export const ageUserColumns = [
    {
      title: '10세',
      align: 'center',
      dataIndex: '10',
      render: (text) => text || 0 
    },
    {
      title: '11세',
      align: 'center',
      dataIndex: '11',
      render: (text) => text || 0 
    },
    {
      title: '12세',
      align: 'center',
      dataIndex: '12',
      render: (text) => text || 0 
    },
    {
      title: '13세',
      align: 'center',
      dataIndex: '13',
      render: (text) => text || 0 
    },
    {
      title: '14세',
      align: 'center',
      dataIndex: '14',
      render: (text) => text || 0 
    },
    {
      title: '합계',
      align: 'center',
      dataIndex: 'total',
    }
  ];
// 큐미르 교육과정 컬럼 
export const classUserColumns = [
    {
      title: '1단계',
      align: 'center',
      dataIndex: 'CURRICULUM1'
    },
    {
      title: '2단계',
      align: 'center',
      dataIndex: 'CURRICULUM2'
    },
    {
      title: '3단계',
      align: 'center',
      dataIndex: 'CURRICULUM3'
    },
    {
      title: '4단계',
      align: 'center',
      dataIndex: 'CURRICULUM4'
    },
    {
      title: '합계',
      align: 'center',
      dataIndex: 'total'
    }
  ];
  
// 교육과정
export const curriculumOptions = 
[
  { label: '전체', value: '-1' },
  { label: '베이직과정', value: '0060000' },
  { label: '그로우/마스터과정', value: '0000000' },
  { label: '초등1과정', value: '0010000' },
  { label: '초등2과정', value: '0050000' },
  // { label: '예비초등3과정', value: '0080000' }
];

// 마케팅동의
export const marketingAgreeOptions = [
  { label: '선택하기', value: -1 },
  { label: '동의', value: 1 },
  { label: '미동의', value: 0 }
];

// 개인정보 수집 및 활용 동의
export const personalInfoAgreeOptions = [
  { label: '동의', value: 1 },
  { label: '미동의', value: 0 }
];

// 승인상태
export const approvalOptions = [
  { label: '전체', value: '-1' },
  { label: '신청', value: '1' },
  { label: '승인', value: '2' },
  { label: '반려', value: '3' }
];

// 주문상태
export const orderStatusOptions = [
  { label: '전체', value: '-1' },
  { label: '주문접수', value: '20' },
  { label: '결제완료', value: '30' },
  { label: '출고준비', value: '40' },
  { label: '발송완료', value: '50' },
  { label: '배송완료', value: '60' },
  { label: '주문취소', value: '70' }
];

// 주문상태 - 신규주문 or 기존주문
export const newOrderYNOptions = [
  { label: '전체', value: '-1' },
  { label: '신규주문', value: '1' },
  { label: '신규주문 제외', value: '0' }
];

// 초도물품 주문상태
export const firstOrderStatusOptions = [
  { label: '전체', value: -1 },
  { label: '신청전', value: 0 },
  { label: '승인대기', value: 1 },
  { label: '본사반려', value: 2 },
  { label: '신청완료', value: 3 },
  { label: '결제완료', value: 4 },
  { label: '출고준비', value: 5 },
  { label: '발송완료', value: 6 },
  { label: '배송완료', value: 7 }
];
// 초도물품 신청상태
export const firstOrderApproveStatusOptions = [
  { label: '전체', value: -1 },
  { label: '신청전', value: 0 },
  { label: '승인대기', value: 1 },
  { label: '본사반려', value: 2 },
  { label: '승인완료', value: 3 }
];

// 교재환불상태
export const bookRefundStatusOptions = [
  { label: '환불상태 전체', value: '-1' },
  { label: '신청중', value: '90' },
  { label: '본사승인완료', value: '91' },
  { label: '본사승인취소', value: '92' },
  { label: '회수진행', value: '97' },
  { label: '교재확인', value: '93' },
  { label: '환불완료', value: '94' },
  { label: '환불취소', value: '95' },
  { label: '배송비 결제하기', value: '96' }
];

// 교재환불상태
export const bookRefundStatusOptions2 = [
  { label: '환불상태 전체', value: '-1' },
  { label: '신청중', value: '90' },
  { label: '회수진행', value: '97' },
  { label: '교재확인', value: '93' },
  { label: '환불완료', value: '94' },
  { label: '환불취소', value: '95' },
];

// 교재환불요청상태
export const bookRefundRequestStatusOptions = [
  { label: '요청상태 전체', value: -1 },
  { label: '패키지환불', value: 1 },
  // { label: '본사승인요청', value: 2 },
  // { label: '본사승인완료', value: 3 },
  { label: '취소신청', value: 4 },
  { label: '취소완료', value: 5 }
];

// 물품환불상태
export const productRefundStatusOptions = [
  { label: '전체', value: '-1' },
  { label: '환불신청중', value: '90' },
  { label: '환불완료', value: '95' },
  { label: '환불취소', value: '96' }
];

// 환불상태변경
export const changeProgressOptions = [
  { label: '진행상태 전체', value: '-1' },
  { label: '신청중', value: '1' },
  { label: '회수진행', value: '2' },
  { label: '환불완료', value: '3' },
  { label: '환불취소', value: '4' }
];

// 배송비결제여부
export const deliveryChargeOptions = [
  { label: '배송비결제여부 전체', value: -1 },
  { label: '배송비결제', value: 1 },
  { label: '배송비미결제', value: 0 }
];

// 회수요청구분
export const recoveryTypeOptions = [
  { label: '회수요청구분 전체', value: -1 },
  { label: '교환', value: 3 },
  { label: '환불', value: 4 }
];

// 주문수정요청구분
export const orderUpdateTypeOptions = [
  { label: '전체', value: -1 },
  { label: '주문오류', value: 2 },
  { label: '오배송', value: 3 }
];

// 주문수정처리상태
export const orderUpdateStatusOptions = [
  { label: '처리상태 전체', value: -1 },
  { label: '신청', value: 1 },
  { label: '승인', value: 2 },
  { label: '반려', value: 3 }
];

// 모니터링처리결과
export const watchResultOptions = [
  { label: '전체', value: '-1' },
  { label: '승인', value: '2' }
];

// 모니터링처리사유
export const resultOptions = [
  {
    label: '전체',
    value: '-1'
  },
  {
    label: '교환 처리 지연으로 인한 정상 주문',
    value: '2'
  },
  {
    label: '환불 처리 지연으로 인한 정상주문',
    value: '3'
  },
  {
    label: '본사 상담을 통한 예외적 승인 주문',
    value: '4'
  },
  {
    label: '지사 상담을 통한 예외적 승인 주문',
    value: '5'
  }
];

// 모니터링사유
export const watchReasonOptions = [
  { label: '사유 전체', value: '-1' },
  { label: '교환 처리 지연으로 인한 정상 주문', value: '2' },
  { label: '환불 처리 지연으로 인한 정상 주문', value: '3' },
  { label: '본사 상담을 통한 예외적 승인 주문', value: '4' },
  { label: '지사 상담을 통한 예외적 승인 주문', value: '5' },
];

// 교재 주문 모니터링 교육원/지사 코멘트(사유)
export const watchProcessStatusOptions = [
  { label: '선택', value: '-1' },
  { label: '교환 처리 지연으로 인한 정상 주문', value: '2' },
  { label: '환불 처리 지연으로 인한 정상 주문', value: '3' },
  { label: '본사 상담을 통한 예외적 승인 주문', value: '4' },
  { label: '지사 상담을 통한 예외적 승인 주문', value: '5' }
];

// 수업승인요청처리결과
export const studyApprovalResultOptions = [
  { label: '전체', value: '-1' },
  { label: '신청', value: '' },
  { label: '승인', value: '' },
  { label: '반려', value: '' }
];

// 환불요청예외승인여부
export const refundExceptionApprovalOptions = [
  { label: '전체', value: '-1' },
  { label: '승인', value: 1 },
  { label: '해제', value: 0 }
];
// 예외교습승인여부
export const exceptionApprovalOptions = [
  { label: '전체', value: '-1' },
  { label: '승인', value: '1' },
  { label: '해제', value: '0' }
];

// 물품판매상태
export const productSaleStatusOptions = [
  { label: '전체', value: '-1' },
  { label: '판매중', value: '1' },
  { label: '판매중단(품절)', value: '0' }
];
// 노출여부
export const productDisplayStatusOptions = [
  { label: '노출', value: 1 },
  { label: '비노출', value: 0 }
];
// 노출단계
export const productDisplayLevelStatusOptions = [
  { label: '본사노출', value: 1 },
  { label: '지사', value: 2 },
  { label: '교육원', value: 3 },
  { label: '교사노출', value: 4 }
];

// SPTP접수상태
export const sptpReceiptStatusOptions = [
  { label: '접수상태 전체', value: '-1' },
  { label: '접수대기', value: '1' },
  { label: '접수완료', value: '2' },
  { label: '승인전', value: '3' },
  { label: '승인', value: '4' },
  { label: '반려', value: '5' }
];

// SPTP결과확인
export const sptpResultOptions = [
  { label: '결과확인 전체', value: '-1' },
  { label: '결과확인O', value: '' },
  { label: '결과확인X', value: '' }
];

// SPTP상담완료
export const sptpCounselOptions = [
  { label: '상담완료 전체', value: '-1' },
  { label: '상담완료O', value: '' },
  { label: '상담완료X', value: '' }
];

// SPTP문의
export const sptpInquiryOptions = [
  { label: '문의 전체', value: '-1' },
  { label: '문의O', value: '' },
  { label: '문의X', value: '' }
];

// SPTP문의처리상태
export const sptpProcessStatusOptions = [
  { label: '전체', value: '-1' },
  { label: '접수', value: '1' },
  { label: '답변완료', value: '2' }
];

// 고객센터문의처리상태
export const inquiryProcessStatusOptions = [
  { label: '전체', value: '-1' },
  { label: '접수', value: '1' },
  { label: '처리중', value: '2' },
  { label: '처리완료', value: '3' },
  { label: '처리불가', value: '4' }
];

// 인지경로 - 입회상담관리
export const joinCognitivePathOptions = [
  { label: 'TV광고', value: '1' },
  { label: '온라인광고(배너,유튜브 등)', value: '2' },
  { label: '오프라인광고(현수막,전단지,버스 등)', value: '3' },
  { label: 'SNS(인스타,블로그,카페 등)', value: '4' },
  { label: '지역 맘카페', value: '5' },
  { label: '지인소개', value: '6' },
  { label: '자녀재원', value: '7' },
  { label: '박람회', value: '8' },
  { label: '입회프로모션', value: '9' },
  { label: '기타', value: '99' }
];

// 인지경로 - 가맹상담관리
export const storeCognitivePathOptions = [
  { label: 'TV광고', value: '1' },
  { label: '온라인광고(배너,유튜브 등)', value: '2' },
  { label: '오프라인광고(현수막,전단지,버스 등)', value: '3' },
  { label: 'SNS(인스타,블로그,카페 등)', value: '4' },
  { label: '지역 맘카페', value: '5' },
  { label: '지인소개', value: '6' },
  { label: '자녀재원', value: '7' },
  { label: '박람회', value: '8' },
  { label: '가맹프로모션', value: '9' },
  { label: '기타', value: '99' }
];

// 회수내역상태
export const recoveryCheckboxOptions = [
  // { label: '취소신청O', value: 'request_status' }, // REQUEST_STATUS = 4
  { label: '메모O', value: 'damage_book_file_path_memo' },
  { label: '사진삽입O', value: 'damage_book_file_path' },
  { label: '파본체크O', value: 'damage_book_yn' },
  { label: '적립금차감O', value: 'use_point_yn' }
];

// 이메일
export const emailOptions = [{ label: '직접입력', value: null }, { value: 'naver.com' }, { value: 'daum.net' }, { value: 'gmail.com' }];

// 강사상태
export const teacherStatusOptions = [
  { label: '재직', value: '1' },
  { label: '휴직', value: '2' },
  { label: '병가', value: '3' },
  { label: '퇴사', value: '4' }
];

//강사 승인상태
export const teacherApproveStatusOptions = [
  { label: '전체', value: -1 },
  { label: '미승인', value: 0 },
  { label: '승인', value: 1 }
];

// 전화번호
export const homePhoneOptions = [{ label: '선택', value: '' }, { value: '02' }, { value: '031' }, { value: '032' }, { value: '033' }, { value: '041' }, { value: '042' }, { value: '043' }, { value: '051' }, { value: '052' }, { value: '053' }, { value: '054' }, { value: '055' }, { value: '061' }, { value: '062' }, { value: '063' }, { value: '064' }];

// 강사직급
export const teacherGradeOptions = [
  { label: '부원장', value: '1' },
  { label: '주임', value: '2' },
  { label: '강사', value: '3' }
];

// 강사직급 필터링
export const teacherGradeSearchOptions = [
  { label: '전체', value: '-1' },
  { label: '부원장', value: '1' },
  { label: '주임', value: '2' },
  { label: '강사', value: '3' }
];

// 게시판열람권한
export const boardAuthOptions = [
  { label: '전체', value: '1' },
  { label: '지사', value: '2' }
];

// 업무게시판구분
export const boardTaskTypeOptions = [
  { label: '전체공지', value: 1 },
  { label: '지사공지', value: 2 },
  { label: '모임자료', value: 3 }
];

// 업무서식구분
export const taskFormTypeOptions = [
  { label: '서식', value: 1 },
  { label: '메뉴얼', value: 2 },
  { label: '표준시안', value: 3 },
  { label: '설명회&상담자료', value: 4 },
  { label: '학부모 안내문', value: 5 },
  { label: '홍보소스', value: 6 },
  { label: '학사/운영일정', value: 7 }
];

// 고객센터문의구분
export const customerCenterInquiryTypeOptions = [
  { label: '전체', value: -1 },
  { label: '물품', value: 2 },
  { label: '교재내용문의', value: 3 },
  { label: '회원정보수정', value: 4 },
  { label: '기타', value: 5 }
];

// 고객센터FAQ구분
export const customerCenterFaqTypeOptions = [
  { label: '전체', value: '-1' },
  { label: '교육관련', value: '1' },
  { label: '회원관련', value: '2' },
  { label: '주문관련', value: '3' },
  { label: '기타', value: '4' }
];

// 회원휴회사유
export const regressReasonOptions = [
  { label: '학습과목이 너무 많음', value: '1' },
  { label: '타 학원으로의 이동', value: '2' },
  { label: '학습속도가 느림', value: '3' },
  { label: '교육원 이동', value: '4' },
  { label: '픽업불가능', value: '5' },
  { label: '이사', value: '6' },
  { label: '환불', value: '7' },
  { label: '기타', value: '8' }
];

// SPTP관리상담완료여부
export const sptpCounselResultOptions = [
  { label: '상담결과 전체', value: '-1' },
  { label: 'O', value: '1' },
  { label: 'X', value: '2' }
];
// 지역구분(영업지역,관리지역)
export const areaTypeOptions = [
  { label: '직영', value: 0 },
  { label: '영업지역', value: 1 },
  { label: '관리지역', value: 2 }
];

// 로그 전송상태
export const logSendStatusOptions = [
  { label: '전체', value: -1 },
  { label: '성공', value: 0 },
  { label: '실패', value: 1 }
];

// SMS로그구분
export const smsLogTypeOptions = [
  { label: 'sms', value: '1' },
  { label: 'mms', value: '2' },
  { label: 'lms', value: '3' }
];

//완료여부
export const completionStatusOption = [
  { label: '완료', value: 1 },
  { label: '미완료', value: 0 }
];
//지사직원채용구분
export const staffEmployTypeOption = [
  { label: '단시간', value: 1 },
  { label: '일반', value: 2 }
];

// 교재 상품 유형
export const ProductBookTypeOptions = [
  { label: '교재', value: 1 },
  { label: '기타/물품', value: 2 },
  { label: '샘플교재', value: 3 }
];
// 교재 상품 유형(재고관리에서 사용)
export const ProductBookTypeStockOptions = [
  { label: '기본교재', value: 1 },
  { label: '물품', value: 2 },
  { label: '물품', value: 3 }
];

// 주문제한
export const limitOrderOption = [
  { label: '전체', value: '-1' },
  { label: '주문제한중', value: '1' }
];

export const statSalesDisplatOption = [
  { label: '합계', value: 'SUM' },
  { label: '매출', value: 'SALES' },
  { label: '환불', value: 'REFUND' }
];

export const scheduleTypeOptions = [
  { label: '본사', value: 1 },
  { label: '지사', value: 2 },
  { label: '지사직원', value: 3 }
];

// 본사 입회상담관리
export const counselHQSearchOptions = [
  { label: '전체', value: '-1' },
  { label: '보호자명', value: '1' },
  { label: '휴대폰번호', value: '2' },
  { label: '지사명', value: '3' },
  { label: '교육원명', value: '4' }
];

// 지사 입회상담관리
export const counselSearchOptions = [
  { label: '전체', value: '-1' },
  { label: '이름', value: '1' },
  { label: '연락처', value: '2' },
  { label: '교육원명', value: '3' }
];

// 교육원 입회상담관리
export const counselSchoolSearchOptions = [
  { label: '전체', value: '-1' },
  { label: '보호자명', value: '1' },
  { label: '휴대폰번호', value: '2' }
];

export const counselStatusSearchOptions = [
  { label: '전체', value: '-1' },
  { label: '지사배정', value: '1' },
  { label: '교육원 배정', value: '2' },
  { label: '상담 완료', value: '3' }
];

export const phoneOptions = [{ label: '010', value: '010' }];

// 설정여부
export const settingYnOptions = [
  { label: '설정안함', value: 0 },
  { label: '설정', value: 1 }
];

// 은행코드
export const bankCodeOptions = [
  { label: '직접입력', value: '' },
  { label: 'KDB산업은행', value: '002' },
  { label: 'IBK기업은행', value: '003' },
  { label: 'KB국민은행', value: '004' },
  { label: '수협은행', value: '007' },
  { label: 'NH농협은행', value: '011' },
  { label: '농협중앙회(단위농축협)', value: '012' },
  { label: '우리은행', value: '020' },
  { label: 'SC제일은행', value: '023' },
  { label: '한국씨티은행', value: '027' },
  { label: '대구은행', value: '031' },
  { label: '부산은행', value: '032' },
  { label: '광주은행', value: '034' },
  { label: '제주은행', value: '035' },
  { label: '전북은행', value: '037' },
  { label: '경남은행', value: '039' },
  { label: '새마을금고중앙회', value: '045' },
  { label: '신협중앙회', value: '048' },
  { label: '저축은행중앙회', value: '050' },
  { label: '산림조합중앙회', value: '064' },
  { label: '우체국', value: '071' },
  { label: '하나은행', value: '081' },
  { label: '신한은행', value: '088' },
  { label: '케이뱅크', value: '089' },
  { label: '카카오뱅크', value: '090' },
  { label: '토스뱅크', value: '092' },
  { label: 'KB증권', value: '218' },
  { label: '미래에셋대우', value: '238' },
  { label: '삼성증권', value: '240' },
  { label: '한국투자증권', value: '243' },
  { label: 'NH투자증권', value: '247' },
  { label: '교보증권', value: '261' },
  { label: '하이투자증권', value: '262' },
  { label: '현대차증권', value: '263' },
  { label: '키움증권', value: '264' },
  { label: '이베스트투자증권', value: '265' },
  { label: 'SK증권', value: '266' },
  { label: '대신증권', value: '267' },
  { label: '한화투자증권', value: '269' },
  { label: '토스증권', value: '271' },
  { label: '신한금융투자', value: '278' },
  { label: 'DB금융투자', value: '279' },
  { label: '유진투자증권', value: '280' },
  { label: '메리츠증권', value: '287' },
  { label: '도이치은행', value: '055' }
];

export const payMethodOptions = [
  {
    label: '관리자승인',
    value: '1'
  },
  {
    label: '카드결제',
    value: '2'
  },
  {
    label: '적립금결제',
    value: '3'
  }
];

export const monitoringStatusOptions = [
  {
    label: '변경할 상태 선택',
    value: '0'
  },
  {
    label: '승인',
    value: '1'
  }
];

export const subjectOptions = [
  {
    label: '전체',
    value: '-1'
  },
  {
    label: '5세과정',
    value: '1'
  },
  {
    label: '한글',
    value: '2'
  },
  {
    label: '수학',
    value: '3'
  },
  {
    label: '한자',
    value: '4'
  },
  {
    label: '칠교',
    value: '5'
  },
  {
    label: '학습향상',
    value: '6'
  },
  {
    label: '언어능력향상',
    value: '7'
  },
  {
    label: '논술을 대체',
    value: '8'
  },
  {
    label: '연산',
    value: '9'
  }
];

export const periodOption = [
  { label: '선택하기', value: -1 },
  { label: '6개월 미만', value: 1 },
  { label: '12개월 미만', value: 2 },
  { label: '1년이상~2년미만', value: 3 },
  { label: '2년이상~3년미만', value: 4 },
  { label: '3년이상~4년미만', value: 5 },
  { label: '4년이상~5년미만', value: 6 }
];

// 주문수정/교환 사유
export const requestReasonDetailOptions = [
  { label: '교재 호수 변경', value: 1 },
  { label: '전체 취소', value: 2 },
  { label: '교재 추가', value: 3 },
  { label: '교습 완료', value: 4 },
  { label: '예외교습승인', value: 5 },
  { label: '오배송', value: 6 },
  { label: '배송누락', value: 7 },
  { label: '교재불량', value: 8 },
  { label: '원장님 주문실수', value: 9 }
];

// 환불 - 사용내역
export const usedStatusOptions = [
  { label: 'X', value: 1 },
  { label: 'O(견본사용)', value: 2 },
  { label: 'O(폐기)', value: 3 }
];

export const regressOptions = [
  { label: '네', value: 1 },
  { label: '아니오', value: 2 }
];

export const promotionPriceOptions = [
  { label: '해당없음', value: 0 },
  { label: '광고홍보비', value: 1 },
  // { label: 'A형', value: 1 },
  // { label: 'B형', value: 2 },
  // { label: 'C형', value: 3 }
];

// 스케줄타입
export const schedueTypeOptions = [
  { label: '일반', value: '0' },
  { label: '휴가', value: '1' },
  { label: '외근', value: '2' }
];


// 스케줄타입
export const noticeTypeOptions = [
  { label: '본사', value: 1 },
  { label: '지사', value: 2 },
  { label: '교육원', value: 3 }
];